import { render, staticRenderFns } from "./menuIndex.vue?vue&type=template&id=a89f3ac0&scoped=true&"
import script from "./menuIndex.vue?vue&type=script&lang=js&"
export * from "./menuIndex.vue?vue&type=script&lang=js&"
import style0 from "./menuIndex.vue?vue&type=style&index=0&id=a89f3ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f3ac0",
  null
  
)

export default component.exports